import {Observable, Subject} from 'rxjs';

export class ModalRef<TResult = unknown> {
  readonly id: string;
  private readonly _afterClosed$ = new Subject<TResult | undefined>();

  constructor(id: string, private readonly _requestClose: (result?: TResult) => void) {
    this.id = id;
  }

  get afterClosed$(): Observable<TResult | undefined> {
    return this._afterClosed$.asObservable();
  }

  close(result?: TResult) {
    this._requestClose(result);
  }

  /** Solo el host/servicio deberían completar esto. */
  _complete(result?: TResult) {
    this._afterClosed$.next(result);
    this._afterClosed$.complete();
  }
}
